(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-carousel-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.swiper.custom-goli-carousel', {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1.1,
    spaceBetween: 30,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 1.2
      },
      1024: {
        slidesPerView: 2.1
      },
      1400: {
        slidesPerView: 2.4
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-row"] && !Shopify.designMode) return;
  try {
    
// Optional JavaScript

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["responsive-image-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('responsive-image-slider')) {
    customElements.define('responsive-image-slider', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.ris-track');
        this.slides = Array.from(this.querySelectorAll('.ris-slide'));
        this.dots = Array.from(this.querySelectorAll('.ris-dot'));
        this.toggle = this.querySelector('[data-toggle]');
        this.index = 0;
        this.paused = false;
        this.hovered = false;
        this.editing = false;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reduced.matches;
        const listen = (target, event, handler) => target?.addEventListener(event, handler, { signal });
        listen(this.querySelector('[data-prev]'), 'click', () => this.go(this.index - 1));
        listen(this.querySelector('[data-next]'), 'click', () => this.go(this.index + 1));
        this.dots.forEach(dot => listen(dot, 'click', () => this.go(Number(dot.dataset.index))));
        listen(this.toggle, 'click', () => { this.paused = !this.paused; this.restart(); });
        listen(this.track, 'scroll', () => {
          const width = this.track.clientWidth;
          if (!width) return;
          this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width)));
          this.update();
          this.restart();
        });
        listen(this.track, 'keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        });
        listen(this, 'mouseenter', () => { this.hovered = true; this.restart(); });
        listen(this, 'mouseleave', () => { this.hovered = false; this.restart(); });
        listen(this, 'focusin', () => this.restart());
        listen(this, 'focusout', () => queueMicrotask(() => this.restart()));
        listen(this, 'pointerdown', () => { this.interacting = true; this.restart(); });
        const endInteraction = () => { this.interacting = false; this.restart(); };
        listen(window, 'pointerup', endInteraction);
        listen(window, 'pointercancel', endInteraction);
        listen(document, 'visibilitychange', () => this.restart());
        listen(this.reduced, 'change', () => { this.paused = this.reduced.matches; this.restart(); });
        listen(document, 'shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (selected < 0) return;
          this.editing = true;
          this.go(selected);
        });
        listen(document, 'shopify:block:deselect', () => { this.editing = false; this.restart(); });
        this.resize = new ResizeObserver(() => {
          this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
        });
        this.resize.observe(this.track);
        this.update();
        this.restart();
      }
      go(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: this.reduced.matches ? 'instant' : 'smooth' });
        this.update();
        this.restart();
      }
      update() {
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
        this.slides.forEach((slide, i) => {
          slide.querySelectorAll('a').forEach(link => { link.tabIndex = i === this.index ? 0 : -1; });
        });
      }
      restart() {
        clearTimeout(this.timer);
        if (this.toggle) {
          this.toggle.textContent = this.paused ? 'Play' : 'Pause';
          this.toggle.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
        }
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused || this.hovered || this.interacting || this.editing || document.hidden || this.contains(document.activeElement)) return;
        this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.delay) || 5000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
        this.resize?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  var swiper = new Swiper('.video-carousel', {
    slidesPerView: 6, /* Default for desktop */
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 3000,

    /* ✅ Add this for responsive */
    breakpoints: {
      0: {         /* 0px and up (mobile first) */
        slidesPerView: 3, 
      },
      768: {       /* 768px and up (tablet) */
        slidesPerView: 4,
      },
      1024: {      /* 1024px and up (desktop) */
        slidesPerView: 6,
      }
    }

  });

  window.openPopup = function(videoUrl, title) {
    var popup = document.getElementById('videoPopup');
    var video = document.getElementById('popupVideo');
    var source = document.getElementById('popupSource');
    var titleEl = document.getElementById('popupTitle');

    source.src = videoUrl;
    video.load();
    video.play();
    titleEl.innerText = title;
    popup.style.display = 'flex';
  }

  window.closePopup = function() {
    var popup = document.getElementById('videoPopup');
    var video = document.getElementById('popupVideo');

    popup.style.display = 'none';
    video.pause();
    video.currentTime = 0;
  }

});

  } catch(e) { console.error(e); }
})();
})();
